import { getPendingRxChangesDetailed } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type {
  GetPendingRxChangesDetailedParams,
  RxChangeDetailedPagedListResponseT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchPendingRxChangesDetailed(
  params: GetPendingRxChangesDetailedParams | undefined,
  signal?: AbortSignal
): Promise<RxChangeDetailedPagedListResponseT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await getPendingRxChangesDetailed(params, config);
  return lotusHealthZod.getPendingRxChangesDetailedResponse.parse(
    response.data
  ) as RxChangeDetailedPagedListResponseT;
}
